// Template204: Bangkok - Consejos útiles página 1 (Tips.jsx). borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template204 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText =
		page?.texts?.[0]?.content ?? "Consejos útiles para viajar a Bangkok";
	const intro = page?.texts?.[1]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};
	const stickerUrl = getCanvasImageUrl("sticker");
	const actualHeaderColor = headerBackgroundColor || "#E8A838";
	const tips =
		Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: 0,
	};
	const blockStyle = {
		backgroundColor: "#fff",
		borderRadius: "12px",
		padding: "12px 14px",
		display: "flex",
		alignItems: "center",
		gap: "10px",
		border: "2px solid #d9e6de",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
			</Box>
			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={p}>
						{intro}
					</Box>
				</Box>
			)}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
					marginTop: isSmallScreen ? 0 : 0,
				}}
			>
				{isSmallScreen && stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{ width: 89, position: "absolute", top: -70, right: -20 }}
					/>
				)}
				{tips.map((tip, i) => (
					<Box key={i} data-block-id={`text-${i + 3}`} sx={blockStyle}>
						<Box sx={{ fontSize: 18 }}>{tip.icono ?? "👔"}</Box>
						<Box sx={{ fontSize: 13, color: contentColor }}>{tip.texto}</Box>
					</Box>
				))}
			</Box>
		</Box>
	);
};

Template204.thumbnail = "/images/template-1.png";
export default Template204;
